import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-card',
  templateUrl: './adc-card.component.html',
  styleUrls: ['./adc-card.component.scss'],
  standalone: false
})
export class AdcCardComponent {
  @Input('data') data: any;
  @Input('type') type: any;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>;

  cardClick() {
    this.clickEvent.emit('Clicked');
  }
}
